<template>
    <!-- eslint-disable max-len -->
    <div class="Section">
        <img v-if="name" :id="name" :src="image" :alt="altText" />
        <h2>{{ getTitle }}</h2>
        <slot></slot>
    </div>
</template>

<script>
import sectionMap from '../sectionMap';

export default {
  name: 'Section',
  props: {
    name: String,
    title: String,
  },
  computed: {
    getTitle() {
      return this.name === undefined ? this.title : sectionMap[this.name].title;
    },
    image() {
      return sectionMap[this.name].image;
    },
    altText() {
      return sectionMap[this.name].alt;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Section {
    margin: 30px 0px;

    img {
        display: block;
        margin: auto;
        width: 125px;
        height: auto;
    }
    h2 {
        text-align: center;
    }
    article {
        @media (min-width: 576px) {
            -webkit-column-count: 1;
            -moz-column-count: 1;
            column-count: 1;
        }
    }
}
</style>
